/* import __COLOCATED_TEMPLATE__ from './registration.hbs'; */
import Component from '@glimmer/component';

import window from 'ember-window-mock';

import { DropdownLanguage } from 'register-partners-js/react/components/dropdown-language/dropdown-language';
import { Topbar } from 'register-partners-js/react/components/topbar/topbar';

import styles from './registration.module.css';

export default class RegistrationLayout extends Component {
  topbar = Topbar;
  dropdownLanguage = DropdownLanguage;

  styles = styles;

  get isSmallScreen() {
    return window.matchMedia?.('(max-width: 776px)').matches;
  }
}
